import { isSubProfile, isUserManaged, userId } from "../../utils/Utils";

export const RAYACORP_USER_ID = 'fb5bdc54-c094-4769-b49d-419d62a69187';

export const GROUPS = [
    { key: 'account',  labelKey: 'account.group.account',  defaultLabel: 'Account' },
    { key: 'security', labelKey: 'account.group.security', defaultLabel: 'Security' },
    { key: 'team',     labelKey: 'account.group.team',     defaultLabel: 'Team' },
    { key: 'billing',  labelKey: 'account.group.billing',  defaultLabel: 'Billing' },
];

// Section keys are stable identifiers used in the URL (?section=<key>).
export const SECTIONS = [
    { key: 'profile',       group: 'account',  labelKey: 'account.nav.profile',       defaultLabel: 'Profile',        icon: 'pi-user' },
    { key: 'notifications', group: 'account',  labelKey: 'account.nav.notifications', defaultLabel: 'Notifications',  icon: 'pi-bell' },
    { key: 'preferences',   group: 'account',  labelKey: 'account.nav.preferences',   defaultLabel: 'Preferences',    icon: 'pi-sliders-h' },
    { key: 'password',      group: 'security', labelKey: 'account.nav.password',      defaultLabel: 'Password',       icon: 'pi-lock' },
    { key: 'two_factor',    group: 'security', labelKey: 'account.nav.two_factor',    defaultLabel: 'Two-factor auth', icon: 'pi-shield' },
    { key: 'signin',        group: 'security', labelKey: 'account.nav.signin_logs',   defaultLabel: 'Sign-in logs',   icon: 'pi-history' },
    { key: 'team',          group: 'team',     labelKey: 'account.nav.team',          defaultLabel: 'Team members',   icon: 'pi-users' },
    { key: 'subscription',  group: 'billing',  labelKey: 'account.nav.subscription',  defaultLabel: 'Subscription',   icon: 'pi-shopping-cart' },
    { key: 'billing',       group: 'billing',  labelKey: 'account.nav.billing',       defaultLabel: 'Billing history', icon: 'pi-money-bill' },
    { key: 'api',           group: 'account',  labelKey: 'account.nav.api',           defaultLabel: 'API',             icon: 'pi-code' },
];

// Mirrors the old Account.js TabView visibility exactly.
export const visibleSectionKeys = () => {
    if (isSubProfile() && userId() === RAYACORP_USER_ID) {
        return ['password'];
    }
    if (isSubProfile()) {
        return ['password', 'two_factor', 'notifications', 'billing'];
    }
    // main profile
    let keys = SECTIONS.map(s => s.key);
    if (isUserManaged()) {
        keys = keys.filter(k => k !== 'subscription' && k !== 'billing');
    }
    return keys;
    // isMainProfile() is implied here; sub-profile branches handled above.
};
